import { useLocation, useParams } from "react-router-dom";
import TradingView from "./TradingView";
import { Button } from "react-bootstrap";
import { ReactComponent as SettingIcon } from "../ui/Icons/setting.svg";
import Modal from "../ui/uiElements/Modal.component";
import ChartSettingForm from "../ui/uiElements/ChartSettingForm";

function AlertCharts() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const data = searchParams.get("data");

  const tickers = data.split(",");
  const splitedData = tickers.map(t => {
    return {
      ticker: t.split("+")[0],
      exchange: t.split("+")[1],
    };
  });

  return (
    <div className="container">
      <Modal>
        <Modal.Open opens="more-details">
          <Button variant="light">
            <SettingIcon fill="black" width="25px" height="25px" /> Charts Settings
          </Button>
        </Modal.Open>
        <Modal.Window name="more-details">
          <ChartSettingForm />
        </Modal.Window>
      </Modal>
      {splitedData.map((item, i) =>
        i % 2 === 0 ? (
          <div key={i} className="row">
            <div className="col-md-6 mt-5 mb-5" style={{ height: "40vh" }}>
            
              <h5>Ticker : <a
                        className="pe-1 text-decoration-none fw-bold"
                        href={"https://www.tradingview.com/chart/mq31yJ7K/?symbol=" + item.ticker}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {item.ticker}
                      </a></h5>
              
              <TradingView ticker={item.ticker} exchange={item.exchange} />
            </div>
            {i + 1 < splitedData.length && (
              <div key={i + 1} className="col-md-6 mt-5 mb-5" style={{ height: "40vh" }}>


                <h5>Ticker : <a
                        className="pe-1 text-decoration-none fw-bold"
                        href={"https://www.tradingview.com/chart/mq31yJ7K/?symbol=" + splitedData[i + 1].ticker}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {splitedData[i + 1].ticker}
                      </a></h5>
                <TradingView ticker={splitedData[i + 1].ticker} exchange={splitedData[i + 1].exchange} />
              </div>
            )}
          </div>
        ) : null
      )}
    </div>
  );
}

export default AlertCharts;
